import Directory from "../../directory/directory.component";

export default function Home() {
  return (
    <>
      <Directory />
    </>
  );
}
